import { render, staticRenderFns } from "./AnimalTable.vue?vue&type=template&id=585be59c&"
import script from "./AnimalTable.vue?vue&type=script&lang=js&"
export * from "./AnimalTable.vue?vue&type=script&lang=js&"
import style0 from "./AnimalTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AnimalTable.vue"
export default component.exports